module.exports = __webpack_public_path__ + "static/KW_Zoom-b95e7d442df35e99dde56a7c5a9ec3da.jpg";